import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import { Media, MediaProps } from '@/components/base/Media'
import Motion from '@/components/base/Motion'
import Section from '@/components/base/Section'
import Typography from '@/components/base/Typography'

import { mediaRevealAnimation } from './animations'
import { cn } from '@/lib/utils'

export type MediaSectionProps = HTMLAttributes<HTMLDivElement> & {
  alignment: 'left' | 'right' | 'center' | 'fullscreen'
  media: MediaProps
  caption: string
}

const MediaSection = ({ alignment, media, caption, ...props }: MediaSectionProps) => {
  return (
    <Motion animation={mediaRevealAnimation}>
      <Section {...props}>
        <Container className={cn(alignment === 'fullscreen' && 'w-screen max-w-none p-0')}>
          <Grid className="relative gap-spacing-sm">
            <div
              className={cn(
                'col-span-4',
                'md:col-span-6',
                'lg:col-span-7',
                alignment === 'left' && 'lg:col-start-2',
                alignment === 'right' && 'lg:order-1 lg:col-start-5',
                alignment === 'center' && 'lg:col-span-10 lg:col-start-2',
                alignment === 'fullscreen' && 'lg:col-span-12 lg:col-start-1'
              )}
            >
              <Media
                {...media}
                className={cn(
                  'border border-solid border-white-dark/30',
                  alignment === 'fullscreen' && 'border-0'
                )}
              />
            </div>
            <div
              className={cn(
                'col-span-4 flex items-end',
                'md:col-span-6',
                'lg:col-span-2',
                alignment === 'left' && 'lg:col-start-10',
                alignment === 'right' && 'lg:-order-1 lg:col-start-2',
                alignment === 'center' &&
                  'ml-0 lg:absolute lg:bottom-spacing-md lg:left-1/2 lg:ml-[calc(var(--gutter)*.5)] lg:w-[20%]',
                alignment === 'fullscreen' &&
                  'ml-[var(--margin)] lg:absolute lg:bottom-spacing-md lg:left-[calc(var(--margin)+var(--gutter)*2.5)] lg:ml-0 lg:w-[20%]'
              )}
            >
              <Typography variant="small" className="text-text-accent-light">
                {caption}
              </Typography>
            </div>
          </Grid>
        </Container>
      </Section>
    </Motion>
  )
}

export default MediaSection
